import { apiClient } from '@/lib/api-client';
import { Org } from '@/types';

/**
 * Fetches the list of organizations from the API.
 * @returns {Promise<Org[]>} A promise that resolves to an array of organizations.
 */
export async function fetchOrganizations(): Promise<Org[]> {
  const res = await apiClient.get<Org[]>('/orgs');

  return res ?? [];
}
